import { Component } from '@angular/core';

@Component({
    selector: 'product',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class ProductComponent {}
